<template>
  <v-app>
    <v-app-bar
      app
      color="black"
      dark
    >
      <a
        href="https://joneslogistics.com/"
        class="zoom"
      >
        <div class="d-flex align-center">
          <v-img
            alt="Jones Logistics"
            class="shrink mr-2"
            contain
            src="@/assets/jones.png"
            transition="scale-transition"
            width="120"
          />
        </div>
      </a>
      <v-spacer></v-spacer>
      <v-btn
        text
        href="https://gohighway.com/onboarding/sign-up/carrier-details"
      >Haul for Jones</v-btn>
    </v-app-bar>

    <v-content>
      <MainLoadboard />
    </v-content>
  </v-app>
</template>

<script>
import MainLoadboard from "./components/MainLoadboard";

export default {
  name: "App",

  components: {
    MainLoadboard
  },

  data: () => ({
    //
  })
};
</script>
<style scoped>
.zoom {
  transition: all 2s;
}

.zoom:hover {
  transform: scale(
    1.1
  ); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}
</style>
